import { getLocationDisplay } from 'components/modules/location/services';
import { multiCaseGet } from 'libs/format';

export function getLocationOptions(locations) {
  const locationOptions = locations.map((location) => {
    const { id: locationId } = location;

    const locationDisplay = getLocationDisplay(location);

    return {
      value: locationId,
      key: locationId,
      text: locationDisplay,
    };
  });

  // Don't allow selection of 'none' option
  locationOptions.unshift({
    value: null,
    key: -1,
    text: 'None',
  });

  return locationOptions;
}

export function getBusinessType(metadata) {
  const canHaveFoodMenus = multiCaseGet(metadata, 'canHaveFoodMenus');
  const canModifyServiceList = multiCaseGet(metadata, 'canModifyServiceList');

  if (canHaveFoodMenus) {
    return 'Food/Restaurant';
  }
  if (canModifyServiceList) {
    return 'Service Business';
  }

  return 'General Business';
}

export function getLocationAddressDisplay(gmbLocation) {
  const storefrontAddress = multiCaseGet(gmbLocation, 'storefrontAddress');
  const addressLines = multiCaseGet(storefrontAddress, 'addressLines');
  const addressText = Array.isArray(addressLines) ? addressLines.join(' ') : '';
  const locality = multiCaseGet(storefrontAddress, 'locality');

  const locationDisplay = [addressText, locality].filter(Boolean).join(', ');
  return locationDisplay || null;
}
